import React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import CircularProgress from '@mui/material/CircularProgress';

type BottomSheetProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  ctaText: string;
  ctaColor?: 'primary' | 'error' | 'warning';
  ctaDisabled?: boolean;
  isLoading?: boolean;
  onConfirm: () => void;
  secondaryAction?: {
    text: string;
    onClick: () => void;
  };
};

export const BottomSheet = ({
  open,
  onClose,
  children,
  ctaText,
  ctaColor = 'primary',
  ctaDisabled = false,
  isLoading = false,
  onConfirm,
  secondaryAction,
}: BottomSheetProps) => {
  const handleClose = () => {
    if (isLoading) return;
    onClose();
  };

  return (
    <Drawer
      anchor="bottom"
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          maxWidth: 540,
          mx: 'auto',
          pb: 'env(safe-area-inset-bottom)',
        },
      }}>
      <Grid container flexDirection="column" gap={2} sx={{ p: 3 }}>
        <Grid container justifyContent="center">
          <Grid
            item
            sx={{
              width: 40,
              height: 4,
              borderRadius: 2,
              backgroundColor: 'grey.300',
            }}
          />
        </Grid>

        {children}

        <Grid container flexDirection="column" gap={1}>
          <Button
            variant="contained"
            fullWidth
            size="large"
            disabled={isLoading || ctaDisabled}
            color={ctaColor}
            onClick={onConfirm}
            sx={{ py: 1.5, fontWeight: 600, fontSize: '1rem' }}>
            {isLoading ? <CircularProgress size={24} color="inherit" /> : ctaText}
          </Button>
          {secondaryAction && (
            <Button
              variant="text"
              fullWidth
              size="large"
              disabled={isLoading}
              onClick={secondaryAction.onClick}
              sx={{ py: 1, fontWeight: 500, color: 'text.secondary' }}>
              {secondaryAction.text}
            </Button>
          )}
        </Grid>
      </Grid>
    </Drawer>
  );
};
